var DEFAULT_REFETCH = function DEFAULT_REFETCH() {};
var DEFAULT_DATA = undefined;

/**
 * Utility to adapt the response of an async hook to the useQuery API
 *
 * Consumers can use this adapter to replace existing useQuery implementations with common async
 * hooks while preserving the useQuery API. This should ease in the transition towards common
 * async hooks.
 *
 * For example, consider a useQuery implementation
 *
 *   const { data, loading, error, refetch } = useQuery<QueryType>({ ... });
 *
 * You can replace this with a common async hook and adapt that response to the useQuery API
 *
 *   const commonHookResult = useCommonAsyncHook({ ... });
 *   const { data, loading, error, refetch } = adaptAsyncHookToUseQueryApi<QueryType>(commonHookResult);
 */
function adaptAsyncHookToUseQueryApi(asyncHookResponse) {
  var status = asyncHookResponse.status;
  switch (status) {
    case 'ok':
      {
        var data = asyncHookResponse.data,
          _asyncHookResponse$re = asyncHookResponse.refetch,
          refetch = _asyncHookResponse$re === void 0 ? DEFAULT_REFETCH : _asyncHookResponse$re;
        return {
          data: data,
          loading: false,
          refetch: refetch
        };
      }
    case 'loading':
      {
        return {
          data: DEFAULT_DATA,
          refetch: DEFAULT_REFETCH,
          loading: true
        };
      }
    case 'error':
      {
        var error = asyncHookResponse.metadata;
        return {
          data: DEFAULT_DATA,
          loading: false,
          refetch: DEFAULT_REFETCH,
          error: error
        };
      }
    case 'skipped':
    default:
      {
        return {
          data: DEFAULT_DATA,
          loading: false,
          refetch: DEFAULT_REFETCH
        };
      }
  }
}
export default adaptAsyncHookToUseQueryApi;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/adaptAsyncHookToUseQueryApi.js
// module id = 4165
// module chunks = 11